import { render, staticRenderFns } from "./project-certificate.html?vue&type=template&id=68c3a0a9&"
import script from "./project-certificate.ts?vue&type=script&lang=ts&"
export * from "./project-certificate.ts?vue&type=script&lang=ts&"
import style0 from "./project-certificate.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports